import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CONSULTAGUIAS_VER_DETALLES, CONSULTAGUIAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import VerDetallesPage from './verDetalles'

export default function ConsultaGuiasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CONSULTAGUIAS_VER_DETALLES}/:id`} component={VerDetallesPage} />
        <Route path={`/${CONSULTAGUIAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
